import { motion } from "framer-motion";

const SERVICES = [
  {
    n: "01",
    title: "Strategic Marketing",
    blurb:
      "Brand strategy, positioning, and executive-level clarity. Long-arc vision translated into quarterly milestones the whole team can execute against.",
    tags: ["Positioning", "Market Analysis", "Trend ID", "Consulting"],
  },
  {
    n: "02",
    title: "Growth & Performance",
    blurb:
      "Paid media, SEO, content engines, and retention programs calibrated to move revenue — measured in ROI, not impressions.",
    tags: ["Paid Media", "SEO", "Social Growth", "Retention"],
  },
  {
    n: "03",
    title: "Content & Creative",
    blurb:
      "Identity systems, messaging architecture, and editorial direction. Creative that earns attention — and deserves to keep it.",
    tags: ["Brand Identity", "Copywriting", "Editorial", "Visual Direction"],
  },
  {
    n: "04",
    title: "Leadership & Management",
    blurb:
      "Senior-level marketing leadership. Teams that retain, clients that renew, relationships built on clear communication and measurable outcomes.",
    tags: ["Team Leadership", "Public Speaking", "Partnerships", "Mentorship"],
  },
  {
    n: "05",
    title: "Experiential & Activation",
    blurb:
      "OOH, murals, popups, and league-scale partnerships. The kind of brand work that earns physical presence in the cities and cultures it enters.",
    tags: ["OOH", "Events", "Sports", "Brand Activation"],
  },
  {
    n: "06",
    title: "Data & Analytics",
    blurb:
      "Clear attribution, structured A/B testing, and reporting built for the people who actually make decisions on the numbers.",
    tags: ["ROI", "A/B Testing", "Attribution", "Insights"],
  },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="px-4 md:px-8 lg:px-12 py-20 md:py-28">
      <div className="mb-10 md:mb-14 max-w-6xl">
        <div className="section-label mb-3 text-[#4A4A4A]">§ 02 — What I Do</div>
        <h2 className="font-anton uppercase text-5xl md:text-7xl lg:text-8xl leading-[0.92]">
          Six
          <span className="font-cormorant italic text-[#D83127] font-semibold"> disciplines </span>
          built to move the needle.
        </h2>
        <p className="font-cormorant italic text-xl md:text-2xl mt-6 max-w-xl text-[#4A4A4A]">
          Full-stack marketing leadership — strategy through spreadsheet, brief through billboard.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-0 hard-border">
        {SERVICES.map((s, i) => (
          <motion.div
            key={s.n}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6, delay: (i % 3) * 0.08 }}
            data-testid={`service-card-${s.n}`}
            className="relative p-6 md:p-8 border-b md:border-r border-[#111111] last:border-b-0 hover:bg-[#E8E4DB] transition-colors group"
            style={{
              borderRightColor: (i + 1) % 3 === 0 ? "transparent" : "#111111",
              borderBottomColor: i >= SERVICES.length - (SERVICES.length % 3 || 3) ? "transparent" : "#111111",
            }}
          >
            <div className="flex items-start justify-between mb-6">
              <div className="font-anton text-6xl md:text-7xl leading-none">{s.n}</div>
              <div className="font-mono-s text-[10px] tracking-[0.25em] uppercase text-[#4A4A4A] mt-2">
                /service
              </div>
            </div>
            <h3 className="font-anton uppercase text-3xl md:text-4xl mb-3 leading-tight">{s.title}</h3>
            <p className="font-work text-base md:text-lg text-[#1a1a1a] leading-relaxed mb-5">{s.blurb}</p>
            <ul className="flex flex-wrap gap-2">
              {s.tags.map((t) => (
                <li
                  key={t}
                  className="font-mono-s text-[10px] uppercase tracking-[0.15em] border border-[#111111] px-2 py-1"
                >
                  {t}
                </li>
              ))}
            </ul>
            <div className="absolute bottom-3 right-4 font-anton text-[#D83127] text-2xl opacity-0 group-hover:opacity-100 transition-opacity">
              →
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
